'use client';

import React from 'react';
import { Box, VStack, Text, HStack } from '@skin-seoul/design-system';
import { TAXONOMY_CATEGORY_LABELS, type TaxonomyCategory } from '@skin-seoul/service';
import LucideIcon from '@/components/ui/LucideIcon';
import { overlay } from 'overlay-kit';
import EfficacyModal from './EfficacyModal';
import SkinConcernModal from './SkinConcernModal';
import SkinTypeConditionModal from './SkinTypeConditionModal';
import { SafeLink } from '@/components/ui/SafeLink';
interface SuitableForItemProps {
  category: TaxonomyCategory;
  items: Array<{
    name: string;
    slug: string;
  }>;
}
const capitalizeFirstLetter = (text: string): string => text.charAt(0).toUpperCase() + text.slice(1);
const SuitableForItem = ({
  category,
  items
}: SuitableForItemProps) => {
  if (items.length === 0) {
    return null;
  }
  const title = TAXONOMY_CATEGORY_LABELS[category];
  const handleQuestionClick = () => {
    switch (category) {
      case 'skinType':
        overlay.open(({
          isOpen,
          close
        }) => <SkinTypeConditionModal isOpen={isOpen} onClose={close} items={items} />);
        break;
      case 'skinConcern':
        overlay.open(({
          isOpen,
          close
        }) => <SkinConcernModal isOpen={isOpen} onClose={close} items={items} />);
        break;
      case 'efficacy':
        overlay.open(({
          isOpen,
          close
        }) => <EfficacyModal isOpen={isOpen} onClose={close} items={items} />);
        break;
      default:
        break;
    }
  };
  return <VStack gap={3} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-component="SuitableForItem" data-sentry-source-file="SuitableForItem.tsx">
      <HStack gap={1} alignItems="center" data-sentry-element="HStack" data-sentry-source-file="SuitableForItem.tsx">
        <Text textStyle={{
        base: 'label.medium',
        tablet: 'label.large'
      }} fontWeight="medium" color="neutral.600" textAlign="left" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="SuitableForItem.tsx">
          {title}
        </Text>
        <Box paddingTop="2px" cursor="pointer" onClick={handleQuestionClick} data-sentry-element="Box" data-sentry-source-file="SuitableForItem.tsx">
          <LucideIcon name="CircleQuestionMark" size="sm" color="neutral.600" data-sentry-element="LucideIcon" data-sentry-source-file="SuitableForItem.tsx" />
        </Box>
      </HStack>
      <HStack gap={2} alignItems="flex-start" flexWrap="wrap" data-sentry-element="HStack" data-sentry-source-file="SuitableForItem.tsx">
        {items.map(({
        name,
        slug
      }, index) => <Box key={index} backgroundColor="neutral.50" borderRadius={8} paddingX={3} paddingY={2}>
            <Text textStyle={{
          base: 'label.medium',
          tablet: 'label.large'
        }} fontWeight="normal" color="primary.400" textAlign="left" whiteSpace="nowrap">
              <SafeLink href={`/product-tag/${slug}`}>{capitalizeFirstLetter(name)}</SafeLink>
            </Text>
          </Box>)}
      </HStack>
    </VStack>;
};
export default SuitableForItem;